
const settings = {
    collectorURL: 'https://api.webcamapi.com/postback/review',
}

export const setImpression = () => {

    if (!localStorage.getItem("userId") || regenerateUserId()) {
        httpRequest({
            impressionId: getUserId(),
            webpath: window.location.pathname,
            queryString: encodeURIComponent(window.location.search),
            eventName: "impression"
        });
    }
}

export const setClickOut = (partner, callBack) => {

    const data = {
        impressionId: getUserId(),
        partner: partner,
        eventName: "clickOut"
    }

    httpRequest(data, callBack);
}

const httpRequest = (params = {}, callBack) => {

    params.webOrigin = window.location.hostname;

    const options = {
        method: "POST",
        body: JSON.stringify(params),
        headers: {
            "Content-Type": "application/json"
        }
    };


    fetch(settings.collectorURL, options).then(req => {
        return req.json();
    }).then(data => {
        if (!data.success) {
            console.error("failed save sqs");
        }
        callBack && callBack();
    }).catch(error => {
        console.error(error)
        callBack && callBack();
    });
}

const getUserId = () => {
    if (!localStorage.getItem("userId") || regenerateUserId()) {
        const userId = generateUserId();
        localStorage.setItem("userId", userId)
        return userId;
    } else {
        return localStorage.getItem("userId")
    }
}

const regenerateUserId = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const adParam = urlParams.get('ad');
    return Boolean(adParam);
}

export const generateUserId = () => {
    const now = new Date();
    const year = now.getUTCFullYear();
    const month = String(now.getUTCMonth() + 1).padStart(2, '0');
    const day = String(now.getUTCDate()).padStart(2, '0');
    const hours = String(now.getUTCHours()).padStart(2, '0');
    const minutes = String(now.getUTCMinutes()).padStart(2, '0');

    return `${year}${month}${day}${hours}${minutes}_${crypto.randomUUID()}`;
}